import { create } from 'zustand';
import { produce } from 'immer';
import { createJSONStorage, persist } from 'zustand/middleware';

// internal
import * as store from '../types/store/client-handle';
import * as state from '../types/store/client-state';

const initState: state.ClientState = {
  select: '',
  auth_client: '',
};

export const useClientStore = create<store.ProjectStore>()(
  persist(
    (set, get) => ({
      ...initState,
      setSelectClient: (client) => {
        set(
          produce<state.ClientState>((state) => {
            state.select = client;
          }),
        );
      },
      setAuthClient: (client) => {
        set(
          produce<state.ClientState>((state) => {
            state.auth_client = client;
          }),
        );
      },
    }),
    {
      name: 'fullloop/client',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
